{
  "version": 1,
  "asset_id": "32eebc45-3e15-4598-8e19-34d58b3dc779",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/32eebc45-3e15-4598-8e19-34d58b3dc779/southend-drone-poster-960.avif",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/32eebc45-3e15-4598-8e19-34d58b3dc779/southend-drone-poster-960.avif",
  "original_filename": "southend-drone-poster-960.avif",
  "size": 54161,
  "content_type": "image/avif",
  "created_at": "2026-07-22T22:52:28Z"
}
